//Utility file

export function truncateToTwoDecimals(num) {
    return Math.trunc(num * 100) / 100;
}